const MONTH_NAMES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

export function formatMonthTitle(year, month) {
  const name = MONTH_NAMES[Number(month) - 1] || "";

  return `${name.charAt(0).toUpperCase()}${name.slice(1)} ${year}`;
}

